
import styles from "../../../styles/CoordinationBoards.module.css"

const NoData = ({ icon }) => {

    const Bubble = ({ size, pos }) => {
        return <div className={styles.atom_orbit}>
            <span className={styles.dot}
                style={{
                    position: "absolute",
                    width: `${size}px`,
                    height: `${size}px`,
                    bottom: `${pos.y}px`,
                    left: `${pos.x}px`
                }}>
            </span>
        </div>
    }

    return (
        <div style={{
            position: "relative",
            width: "200px",
            height: "150px"
        }}>
            <Bubble
                size="19"
                pos={{ x: 52, y: 35 }}
            />
            <Bubble
                size="22"
                pos={{ x: 138, y: 92 }}
            />
            <Bubble
                size="25"
                pos={{ x: 40, y: 100 }}
            />
            <span
                style={{ height: "75px", width: "75px", marginTop: "40px" }}
                className={styles.dot}
            >
                {icon ?
                    icon
                    : <span
                        className="material-icons"
                        style={{
                            color: "#883cae",
                            fontSize: "60px",
                            padding: "8px",
                        }}
                    >
                        post_add
                    </span>}
            </span>
        </div>
    )
}
export default NoData

